import Cookies from 'js-cookie'
import Login from '../components/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

// 页面组件
import UserManagement from '../views/UserManagement.vue'
import UserDetail from '../views/UserDetail.vue'
import CouponDetail from '../views/CouponDetail.vue'
import StoreManagement from '../views/StoreManagement.vue'
import OrderCenter from '../views/OrderCenter.vue'
import ProductManagement from '../views/ProductManagement.vue'
import ProductCategory from '../views/ProductCategory.vue'
import AddProduct from '../views/AddProduct.vue'
import Coupon from '../views/CouponManagement.vue'
import MiniProgram from '../views/MiniProgram.vue'
import UserAddress from '../views/UserAddress.vue'
import ComponentPreview from '../views/ComponentPreview.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      // 用户管理
      {
        path: 'user',
        children: [
          {
            path: '',
            name: 'UserManagement',
            component: UserManagement
          },
          {
            path: 'info',
            name: 'UserInfo',
            component: UserDetail
          },
          {
            path: 'coupon',
            name: 'CouponManagement',
            component: CouponDetail
          },
          {
            path: 'UserAddress',
            name: 'UserAddress',
            component: UserAddress
          }
        ]
      },
      // 门店管理
      {
        path: 'store',
        name: 'Store',
        component: StoreManagement
      },
      // 订单中心
      {
        path: 'order',
        name: 'Order',
        component: OrderCenter
      },
      // 商品管理
      {
        path: 'product',
        children: [

          {
            path: '', // 默认子路由
            name: 'ProductManagement',
            component: ProductManagement
          },
          {
            path: 'category',
            name: 'ProductCategory',
            component: ProductCategory
          },
          {
            path: 'add',
            name: 'AddProduct',
            component: AddProduct
          }
        ]
      },
      // 优惠券
      {
        path: 'coupon',
        name: 'Coupon',
        component: Coupon
      },
      // 页面设计
      {
        path: 'diypage',
        name: 'ComponentPreview',
        component: ComponentPreview
      },

      // 小程序
      {
        path: 'mini',
        name: 'MiniProgram',
        component: MiniProgram
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory('/shop/'),
  routes
})
// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isLoginPage = to.path === '/login'

  // 认证检查逻辑
  if (requiresAuth) {
    if (isAuthenticated) {
      // 已认证访问管理后台
      if (to.path === '/') {
        // 根据设计图默认跳转门店管理
        next('/store')
        return
      }
      next()
    } else {
      // 未认证重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else if (isLoginPage) {
    // 登录页特殊处理
    if (isAuthenticated) {
      next('/store') // 已登录强制跳转管理界面
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router